import React, { useState, useEffect } from 'react';
import Navbar from '../../components/public/Navbar';
import Footer from '../../components/public/Footer';
import PageHeader from '../../components/public/PageHeader';
import ProductsSection from '../../components/public/ProductsSection';
import { publicPosApi } from '../../services/api';

export default function ProductsPage() {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

      useEffect(() => {
    const loadData = async () => {
      try {
        // Fetch directly from service items and packages APIs
        const [itemsRes, packagesRes] = await Promise.all([
          publicPosApi.getItems({ status: true }),
          publicPosApi.getPackages({ status: true }),
        ]);

        // Handle paginated response - data.data.data is the array
        const itemsData = itemsRes.data?.data?.data || [];
        const packagesData = packagesRes.data?.data?.data || [];

        const items = Array.isArray(itemsData) ? itemsData : [];
        const packages = Array.isArray(packagesData) ? packagesData : [];

        // Transform API data into ProductsSection format
        const transformedItems = items.map(item => ({
          name: item.name,
          description: item.short_description || item.description,
          long_description: item.description,
          image_url: item.image_url,
          price: item.price ? `Rp ${parseInt(item.price).toLocaleString('id-ID')}` : 'Hubungi',
          features: item.features ? (Array.isArray(item.features) ? item.features : []) : [],
          faq: item.faq ? (Array.isArray(item.faq) ? item.faq : []) : [],
          badge: item.badge || null,
        }));

        const transformedPackages = packages.map(pkg => ({
          name: pkg.name,
          description: pkg.short_description || pkg.description,
          long_description: pkg.description,
          image_url: pkg.image_url,
          price: pkg.base_price ? `Rp ${parseInt(pkg.base_price).toLocaleString('id-ID')}` : 'Hubungi',
          features: pkg.features ? (Array.isArray(pkg.features) ? pkg.features : []) : [],
          faq: pkg.faq ? (Array.isArray(pkg.faq) ? pkg.faq : []) : [],
          badge: pkg.badge || null,
        }));

        // Create sections with items and packages
        const newSections = [];
        if (items.length > 0) {
          newSections.push({
            id: 'items',
            type: 'products',
            content: {
              title: 'Produk & Layanan Kami',
              subtitle: 'Pilih produk dan layanan pembersih yang sesuai dengan kebutuhan Anda',
              products: transformedItems,
            },
          });
        }
        if (packages.length > 0) {
          newSections.push({
            id: 'packages',
            type: 'products',
            content: {
              title: 'Paket Layanan Premium',
              subtitle: 'Paket bundling hemat untuk kebutuhan pembersihan menyeluruh',
              products: transformedPackages,
            },
          });
        }

        if (newSections.length > 0) {
          setSections(newSections);
        } else {
          setError('Tidak ada produk yang tersedia saat ini.');
        }
      } catch (err) {
        setError(err.response?.data?.message || 'Gagal memuat produk. Silahkan coba lagi.');
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      {loading ? (
        <div className="min-h-screen flex items-center justify-center bg-bg-light pt-20">
          <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
        </div>
      ) : error ? (
        <div className="min-h-screen flex items-center justify-center bg-bg-light pt-20">
          <div className="text-center">
            <p className="text-red-600 mb-4">{error}</p>
            <button onClick={() => window.location.reload()} className="bg-brand text-navy px-6 py-2 rounded-full hover:bg-brand-dark font-semibold">Coba Lagi</button>
          </div>
        </div>
      ) : (
        <>
          <PageHeader title="Produk Kami" subtitle="Pembersih eco-enzyme untuk setiap kebutuhan" />
          {sections.length > 0 ? (
            sections.map(s => {
              if (s.type !== 'products') return null;
              const parsedContent = typeof s.content === 'string' ? (() => { try { return JSON.parse(s.content); } catch { return {}; } })() : s.content;
              return <ProductsSection key={s.id} content={parsedContent} />;
            })
          ) : (
            <div className="py-20 text-center text-gray-600">
              <p>Belum ada produk yang tersedia</p>
            </div>
          )}
        </>
      )}
      <Footer />
    </div>
  );
}